import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import { HighlightedProductsHeaderConfig } from '../../../constants/merchCards/HighlightedProductsHeaderConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardLowerTierMessage = ({
  productLine,
  productLevel,
  handleClick,
  isFreePortal
}) => {
  // TODO - these translations are all coming from SSAPI, migrate to new format
  const config = HighlightedProductsHeaderConfig[productLine][productLevel];
  const lowerTierPlus = config.lowerTierPlus || '';
  if (productLevel === FREE) {
    return /*#__PURE__*/_jsx(Link, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.includes"
      })
    });
  }
  if (productLevel === STARTER && isFreePortal) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "merchCards.businessObjectives.freeToolsPlus",
      options: {
        freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(Link, {
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.businessObjectives.freeToolsWithLimits"
          })
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: lowerTierPlus
  });
};